<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Config
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Config')"><v-icon small class="mr-2">fa-plus</v-icon> Add Record</v-btn>
                    <config-record-dialog v-model="dialog" :item="editedItem"></config-record-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="config"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.config_id }}</td>
        <td class="text-xs-left">
            {{props.item.config_name}}
        </td>
        <td class="text-xs-left">{{ props.item.facility_name}}</td>
        <td class="text-xs-left">{{ props.item.config}}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'Config') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'Config') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getConfig, deleteConfig} from '../helper'
import ConfigRecordDialog from '../components/config/ConfigRecordDialog'

export default {
    name: 'Config',
  components: { ConfigRecordDialog },
  data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Config ID ',
          align: 'left',
          sortable: true,
          value: 'config_id',
        },
        { text: 'Config Name ', value: 'config_name' },
        { text: 'Facility Name ', value: 'facility_name'},
        { text: 'Config ', value: 'config'},
        { text: 'Action ', sortable: false },
      ],
      config: [
        {
          'config_id': 1,
          'config_name': 'Configuration Name',
          'facility_name': 'Facility Name',
          'config': 'Config',
        },
      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
    watch: {
      dialog () {
        this.refresh()
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.config.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.config.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.config.splice(index, 1)
          await deleteConfig({
            'config_id': item.config_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.config[this.editedIndex], this.editedItem)
        } else {
          this.config.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getConfig({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.config = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
